<template>
  <v-app id="payment">
    <v-content class="good-gray">
      <div id="payment-container">
        <v-alert text :color="v_alert.color" border="left" :type="v_alert.type"
                 class="pa-6 mx-5 w-100" v-if="v_alert.displayed">{{v_alert.text}}
        </v-alert>
        <p>Steppi</p>
        <h2>Steppi B.V.</h2>
        <h2>€ {{amount }}</h2>
        <div class="paymentmethods-container">
          <div class="payment-line" @click="payIdeal()">
            <label>iDEAL</label>
            <span>></span>
          </div>
          <div class="payment-line" @click="goToCreditcard()">
            <label>Creditcard</label>
            <span>></span>
          </div>
          <div class="payment-line" @click="payBancontact()">
            <label>Bancontact</label>
            <span>></span>
          </div>
        </div>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  data: () => ({
    amount: "",
    v_alert: {
      color: "",
      type: "",
      text: "",
      displayed: false,
    }
  }),
  mounted() {
    var payment = this.$route.params;
    this._getLink([payment.id, payment.secret]).then((data) => {
      if(data !== 'good'){
        if(data !== ''){
          alert(data);
        }
        this.wrong();
       // window.location.href = "https://www.steppi.nl";
      }
      this.amount = this.payment.total;

    })
  },
  computed: {
    ...mapState({
      payment: state => state.payment.payment,
      link: state => state.payment.link,
    })
  },
  methods: {
    ...mapActions('payment', [
      '_getLink',
      '_bancontactPaymentLink',
      '_idealPayment',
    ]),

    payIdeal(){
      this.loading();
      this._idealPayment(['ing', this.payment]) // Hard coded bank ignored by Stripe
          .then((data) => {
            if(data!==undefined || data){
              this.perfect();
              window.location.href = data;
            }else{
              this.wrong();
            }
          })
          .catch(() => {
            this.wrong();
          });},
    redirectCountry(){
      // er is gesjoemeld met de betaling.
      //this.$router.push({ name: 'country'});
    },
    goToCreditcard(){
      this.$router.push({ name: 'creditcard', params: {id: this.payment.id, secret: this.link.secret}});
    },
    payBancontact(){
      this.loading();
      this.payment.description = this.link.description;

      this._bancontactPaymentLink(this.payment)
          .then((data) => {
            this.perfect();
            window.location.href=data;
          });
    },
    wrong(){
      this.v_alert.color = "red";
      this.v_alert.type = "error";
      this.v_alert.text = "Er is iets mis gegaan, probeer het opnieuw";
      this.v_alert.displayed = true;
    },
    loading(){
      this.v_alert.color = "blue";
      this.v_alert.type = "info";
      this.v_alert.text = "Een betaling wordt gemaakt";
      this.v_alert.displayed = true;
    },
    perfect(){
      this.v_alert.color = "green";
      this.v_alert.type = "success";
      this.v_alert.text = "U wordt door gestuurd";
      this.v_alert.displayed = true;
    },
  }
};
</script>
<style src="../Payment/Payment.scss" scoped lang="scss"></style>

